








import { Component, Vue, Watch } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
export default class Welcome extends Vue {
    public backgroundImagePosition: number = 0;
    public displayState: string = "flex";

    @State("scrollPosition")
    public scrollPosition: number;

    @Watch("scrollPosition")
    private handleScrollPositionChange() {
        this.backgroundImagePosition = 0 - this.scrollPosition / 5;
        this.displayState = this.scrollPosition > window.innerHeight ? "none" : "flex";
    }
}
